var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDrivingLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4502 25.5601H45.4502V28.5601H65.4502V25.5601Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9502 26.0601C21.5945 26.0601 16.9802 29.3358 14.9938 33.969C14.3223 35.5352 13.9502 37.2575 13.9502 39.0601C13.9502 46.2135 19.7968 52.0601 26.9502 52.0601C34.1036 52.0601 39.9502 46.2135 39.9502 39.0601C39.9502 37.2575 39.5781 35.5352 38.9066 33.969C36.9201 29.3358 32.3059 26.0601 26.9502 26.0601ZM26.9502 37.43L18.4486 33.8132C20.2197 30.9626 23.3787 29.0601 26.9502 29.0601C30.5217 29.0601 33.6807 30.9626 35.4517 33.8132L26.9502 37.43ZM28.4502 40.052L36.6343 36.5703C36.8404 37.3665 36.9502 38.2006 36.9502 39.0601C36.9502 44.0472 33.2429 48.2167 28.4502 48.9468V40.052ZM25.4502 40.052V48.9468C20.6575 48.2167 16.9502 44.0472 16.9502 39.0601C16.9502 38.2006 17.06 37.3665 17.2661 36.5703L25.4502 40.052Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4502 33.5601H65.4502V36.5601H45.4502V33.5601Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4502 41.5601H45.4502V44.5601H65.4502V41.5601Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4502 49.5601H55.4502V52.5601H45.4502V49.5601Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4502 21.3601C6.4502 18.1568 9.04694 15.5601 12.2502 15.5601H67.7502C70.9535 15.5601 73.5502 18.1568 73.5502 21.3601V59.2601C73.5502 62.4633 70.9534 65.0601 67.7502 65.0601H12.2502C9.04694 65.0601 6.4502 62.4633 6.4502 59.2601V21.3601ZM12.2502 18.5601H67.7502C69.2966 18.5601 70.5502 19.8137 70.5502 21.3601V59.2601C70.5502 60.8065 69.2966 62.0601 67.7502 62.0601H12.2502C10.7038 62.0601 9.4502 60.8065 9.4502 59.2601V21.3601C9.4502 19.8137 10.7038 18.5601 12.2502 18.5601Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrivingLicense);
export default __webpack_public_path__ + "static/media/Icon-driving_license.6145092803efc30c159a4c5c993a0dbc.svg";
export { ForwardRef as ReactComponent };